// @ts-ignore
import { getDeviceIDFromLocalStorage, setDeviceIDToLocalStorage } from './deviceIDStorageUtils';
/**
 * Sets the device id to the value from local storage or sets the local storage property to the current device id value.
 * NOTE: The device id is stored in JSON because the library used by Jitsi Meet wrappers to read/write it is working
 * with this format.
 *
 * @param {AmplitudeClient} amplitude - The amplitude instance.
 * @returns {Promise}
 */
export function fixDeviceID(amplitude) {
    const deviceId = getDeviceIDFromLocalStorage();
    if (deviceId) {
        amplitude.setDeviceId(deviceId);
    }
    else {
        setDeviceIDToLocalStorage(amplitude.options.deviceId);
    }
    return Promise.resolve(true);
}
